import type { ProfileRes } from 'src/entities/profile'
import { defineStore } from 'pinia'
import { getProfile } from 'src/use-cases/profile'

interface IStateProfile {
  profile: ProfileRes | null
}

export const useProfileStore = defineStore('profile', {
  state: (): IStateProfile => ({
    profile: null,
  }),
  actions: {
    async fetchProfile() {
      const data = await getProfile.execute()
      this.profile = data
      return data
    },
  },
  persist: true,
})
